import { HeartOutlined } from "@ant-design/icons";
import CakeOutlinedIcon from "@mui/icons-material/CakeOutlined";
import { Badge, useMediaQuery } from "@mui/material";
// import { BarChart } from "@mui/x-charts/BarChart";
import { Button, Col, Row, Typography } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { CREATE_jwel } from "../Config/Config";
import Header from "../Header";
import SidebarDrawer from "../SidebarDrawer";
import style from "./Dashboard.module.css";
import CustomTooltip from "./CustomToolTip";

const Dashboard = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [totalSaleBill, setTotalSaleBill] = useState(0);
  const [totalSaleAmt, setTotalSaleAmt] = useState(0);
  const [totalCash, setTotalCash] = useState(0);
  const [totalCard, setTotalCard] = useState(0);
  const [totalOnline, setTotalOnline] = useState(0);
  const [totalUpi, setTotalUpi] = useState(0);
  const [totalCheque, setTotalCheque] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalSalesGraph, setTotalSalesGraph] = useState([]);
  const [totalPurchaseBill, setTotalPurchaseBill] = useState(0);
  const [totalPurchaseAmt, setTotalPurchaseAmt] = useState(0);
  const [totalPurchaseGraph, setTotalPurchaseGraph] = useState([]);
  const [topTenInvoices, setTopTenInvoices] = useState([]);
  const [salesGraph, setSalesGraph] = useState([]);
  const [birthDayData, setBirthDayData] = useState([]);
  const [todayAnniversaryData, setTodayAnniversaryData] = useState([]);
  // const [imagesData, setImagesData] = useState([]);
  // const [userArea, setUserArea] = useState();
  // const [userName, setUserName] = useState();
  // const [singleImage, setSingleImage] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);

  const colorMap = {
    Monday: [
      " #d9dba4",
      "violet",
      " #75b7b3",
      " #162566",
      " #52bd91",
      " #cc92c1",
      " #f4a261",
    ],
    Tuesday: [
      " #f94144",
      " #f3722c",
      " #f8961e",
      " #f9844a",
      " #f9c74f",
      " #90be6d",
      " #43aa8b",
    ],
    Wednesday: [
      " #577590",
      " #277da1",
      " #4d908e",
      " #43aa8b",
      " #90be6d",
      " #f9c74f",
      " #f9844a",
    ],
    Thursday: [
      " #a29bfe",
      " #81ecec",
      " #fab1a0",
      " #fd79a8",
      " #e17055",
      " #00b894",
      " #6c5ce7",
    ],
    Friday: [
      " #00cec9",
      " #0984e3",
      " #6c5ce7",
      " #fd79a8",
      " #e84393",
      " #2d3436",
      " #ffeaa7",
    ],
    Saturday: [
      " #ff7675",
      " #74b9ff",
      " #a29bfe",
      " #00b894",
      " #ffeaa7",
      " #fab1a0",
      " #fdcb6e",
    ],
    Sunday: [
      " #636e72",
      " #2d3436",
      " #dfe6e9",
      " #b2bec3",
      " #ffeaa7",
      " #fdcb6e",
      " #e17055",
    ],
  };
  const dayOfWeek = new Date().toLocaleDateString("en-US", { weekday: "long" });
  const color = colorMap[dayOfWeek] || colorMap.Monday;
  const colors = ["#FFBB28", "#FF8042", "#0088FE", "black"];
  const barColors = colorMap[dayOfWeek] || colorMap.Monday;
  // const barColors = [
  //   "#d9dba4",
  //   "violet",
  //   "#75b7b3",
  //   "#162566",
  //   "#52bd91",
  //   "#cc92c1",
  // ];

  const imageUrls = localStorage.getItem("images")?.split(",");
  const imagesData = imageUrls?.length > 0 ? imageUrls : [];
  const userArea = localStorage.getItem("city");
  const userName = localStorage.getItem("user");
  const singleImage = localStorage.getItem("singleImage");
  const tenantName = localStorage.getItem("tenantName");

  const toggleDrawer = () => {
    setOpen(false);
  };

  const totalSaleBillAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTotalBills?billDate=${dayjs().format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setTotalSaleBill(data[0].Expr1);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const totalSaleAmtAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTotalSaleValue?billDate=${dayjs().format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setTotalSaleAmt(data[0].AMT);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  // const TotalCashAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetTotalCashSale?billDate=${dayjs().format(
  //         "MM/DD/YYYY"
  //       )}`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       setTotalCash(data[0].CASH);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  // const TotalCardAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetTotalCardSale?billDate=${dayjs().format(
  //         "MM/DD/YYYY"
  //       )}`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       setTotalCard(data[0].Expr2);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  const collectionsAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CREDIT_BILLMAST&where=BILLDATE='${dayjs().format(
          "MM/DD/YYYY"
        )}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        const totalCash = data.reduce((acc, item) => {
          const jama = Number(item.PAIDCASH) || 0;
          return acc + jama;
        }, 0);

        const totalCard = data.reduce((acc, item) => {
          const jama = Number(item.PAIDCARD) || 0;
          return acc + jama;
        }, 0);

        const totalOnline = data.reduce((acc, item) => {
          const jama = Number(item.PAIDONLINE) || 0;
          return acc + jama;
        }, 0);

        const totalUpi = data.reduce((acc, item) => {
          const jama = Number(item.PAIDUPI) || 0;
          return acc + jama;
        }, 0);

        const totalCheque = data.reduce((acc, item) => {
          const jama = Number(item.PAIDCHEQUE) || 0;
          return acc + jama;
        }, 0);

        const totalBalance = data.reduce((acc, item) => {
          const jama = Number(item.BALANCE) || 0;
          return acc + jama;
        }, 0);
        setTotalCash(totalCash);
        setTotalCard(totalCard);
        setTotalOnline(totalOnline);
        setTotalUpi(totalUpi);
        setTotalCheque(totalCheque);
        setTotalBalance(totalBalance);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const TotalSalesGraphAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetComodityWiseSale?billStartDate=${dayjs().format(
          "MM/DD/YYYY"
        )}&billEndDate=${dayjs().format("MM/DD/YYYY")}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        const transformedData = data.map((item) => ({
          date: item.PTYPE, // or any other label you want on the X-axis
          amt: item.AMOUNT,
          QTY: item.QTY,
        }));
        setTotalSalesGraph(transformedData);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const totalPurchaseBillAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTotalPurchaseCount?billDate=${dayjs().format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setTotalPurchaseBill(data[0].Expr1);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const totalPurchaseAmtAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTotalPurchaseValue?billDate=${dayjs().format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setTotalPurchaseAmt(data[0].AMT);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };
  const TotalPurchaseGraphAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetComodityWisePurchase?billStartDate=${dayjs().format(
          "MM/DD/YYYY"
        )}&billEndDate=${dayjs().format("MM/DD/YYYY")}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        if (Array.isArray(data) && data.length > 0) {
          const transformedData = data.map((item) => ({
            date: item.PTYPE, // or any other label you want on the X-axis
            amt: item.AMOUNT,
            QTY: item.QTY,
          }));
          setTotalPurchaseGraph(transformedData);
        }
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };
  const TopTenInvoiceAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTopTenBills?billStartDate=${dayjs().format(
          "MM/DD/YYYY"
        )}&billEndDate=${dayjs().format("MM/DD/YYYY")}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;
      const topTen = data.sort((a, b) => b.AMOUNT - a.AMOUNT).slice(0, 10);
      setTopTenInvoices(topTen);
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const todayBirthdayAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=DOB='${dayjs().format(
          "MM/DD/YYYY"
        )}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setBirthDayData(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };
  const todayAnniversaryAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhere?tableName=CUSTOMER&where=ANNVERSARY='${dayjs().format(
          "MM/DD/YYYY"
        )}'`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setTodayAnniversaryData(data);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  // const userAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       const imageUrls = data[0]?.EPASS1.split(",");
  //       setImagesData(imageUrls);
  //       setUserName(data[0]?.FIRMNAME);
  //       setUserArea(data[0]?.CITY);
  //       setSingleImage(data[0]?.EPASS2);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  const fetchTotalSaleAmt = async (date) => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetTotalSaleValue?billDate=${dayjs(date).format(
          "MM/DD/YYYY"
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        }
      );

      const data = response.data;
      return Array.isArray(data) && data.length > 0 ? data[0].AMT : 0;
    } catch (error) {
      console.error("Error fetching sale amount for", date, ":", error);
      return 0;
    }
  };

  useEffect(() => {
    const loadSalesData = async () => {
      const dates = [0, 1, 2, 3].map((d) => dayjs().subtract(d, "day"));
      const results = await Promise.all(
        dates.map((date) =>
          fetchTotalSaleAmt(date).then((amt) => ({
            date: dayjs(date).format("DD-MMM"),
            amt: amt,
          }))
        )
      );
      // Reverse so oldest comes first (if needed)
      setSalesGraph(results.reverse());
    };

    loadSalesData();
  }, []);

  const collections = [
    { name: "Cash", amount: `₹ ${totalCash?.toFixed(2) || 0}` },
    { name: "Card", amount: `₹ ${totalCard?.toFixed(2) || 0}` },
    { name: "Online", amount: `₹ ${totalOnline?.toFixed(2) || 0}` },
    { name: "UPI", amount: `₹ ${totalUpi?.toFixed(2) || 0}` },
    { name: "Cheque", amount: `₹ ${totalCheque?.toFixed(2) || 0}` },
    { name: "Balance", amount: `₹ ${totalBalance?.toFixed(2) || 0}` },
  ];

  const salesData = [
    { month: "Jan", sales: 200 },
    { month: "Feb", sales: 150 },
    { month: "Mar", sales: 180 },
    { month: "Apr", sales: 220 },
    { month: "May", sales: 190 },
    { month: "Jun", sales: 240 },
  ];

  useEffect(() => {
    const fetchData = () => {
      totalSaleBillAPI();
      totalSaleAmtAPI();
      // TotalCashAPI();
      // TotalCardAPI();
      TotalSalesGraphAPI();
      totalPurchaseBillAPI();
      totalPurchaseAmtAPI();
      TotalPurchaseGraphAPI();
      TopTenInvoiceAPI();
      collectionsAPI();
      todayBirthdayAPI();
      todayAnniversaryAPI();
      // userAPI();
    };

    fetchData();

    const intervalId = setInterval(fetchData, 2000);

    return () => clearInterval(intervalId);
  }, []);

  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width: 960px)");
  const defaultGraphData = [{ PTYPE: "No Data", AMOUNT: 0, QTY: 0 }];
  const defaultSalesGraphData = [{ PTYPE: "No Data", AMOUNT: 0 }];

  const getPath = (x, y, width, height) => {
    return `M${x},${y + height}C${x + width / 3},${y + height} ${
      x + width / 2
    },${y + height / 3}
    ${x + width / 2}, ${y}
    C${x + width / 2},${y + height / 3} ${x + (2 * width) / 3},${y + height} ${
      x + width
    }, ${y + height}
    Z`;
  };

  const TriangleBar = (props) => {
    const { fill, x, y, width, height } = props;

    return <path d={getPath(x, y, width, height)} stroke="none" fill={fill} />;
  };

  useEffect(() => {
    if (imagesData.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imagesData.length);
      }, 1500);
      return () => clearInterval(interval);
    }
  }, [imagesData]);

  return (
    <div>
      <Header setOpen={setOpen} />
      <div className={style.carouselContainer}>
        <div
          className={style.carouselSlider}
          style={{
            transform: `translateX(-${currentIndex * 33.33}%)`,
            width: `${imagesData.length * 100}%`,
          }}
        >
          {imagesData.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`img-${index}`}
              className={style.carouselImage}
            />
          ))}
        </div>
      </div>
      <div className={style.dashboardContainer}>
        <div className={style.salesCard}>
          <div className={style.salesHeader}>Sale</div>
          <div className={style.salesContent}>
            <Row justify="space-between">
              <Typography.Text className={style.salesText}>
                Total Bills: <b>{totalSaleBill}</b>
              </Typography.Text>
              <Typography.Text className={style.salesText}>
                Total Sale: <b>₹ {totalSaleAmt?.toFixed(2) || 0}</b>
              </Typography.Text>
            </Row>
          </div>
        </div>
        <div className={style.collectionsTitle}>Collections</div>
        <Row gutter={[16, 16]} justify="center">
          {collections.slice(0, 3).map((item, index) => (
            <Col
              key={index}
              xs={8}
              sm={8}
              md={8}
              lg={4}
              className={style.collectionCol}
            >
              <div bordered className={style.collectionCard}>
                <Typography.Text className={style.collectionText}>
                  {item.name}
                </Typography.Text>
                <Typography.Title level={5} className={style.collectionAmount}>
                  <span style={{ fontWeight: "bold" }}>{item.amount}</span>
                </Typography.Title>
              </div>
            </Col>
          ))}
        </Row>
        <Row gutter={[16, 16]} justify="center">
          {collections.slice(3, 6).map((item, index) => (
            <Col
              key={index}
              xs={8}
              sm={8}
              md={8}
              lg={4}
              className={style.collectionCol}
            >
              <div bordered className={style.collectionCard}>
                <Typography.Text className={style.collectionText}>
                  {item.name}
                </Typography.Text>
                <Typography.Title level={5} className={style.collectionAmount}>
                  <span style={{ fontWeight: "bold" }}>{item.amount}</span>
                </Typography.Title>
              </div>
            </Col>
          ))}
        </Row>
        <div className={style.totalSalesTitle}>Comodity Wise Sale</div>
        <div className={style.barChartContainer}>
          <BarChart
            width={500}
            height={300}
            data={
              totalSalesGraph.length ? totalSalesGraph : [{ date: "", amt: 0 }]
            }
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 14, fontWeight: "bold", fill: "#555" }}
            />
            <YAxis domain={[0, 1000]} />
            {totalSalesGraph.length && <Tooltip content={<CustomTooltip />} />}
            <Bar
              dataKey="amt"
              fill="#8884d8"
              label={{ position: "top" }}
              barSize={60}
            >
              {(totalSalesGraph.length ? totalSalesGraph : [{ amt: 0 }]).map(
                (entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={color[index % color.length]}
                  />
                )
              )}
            </Bar>
          </BarChart>
        </div>
        <div className={style.totalPurchasesTitle}>
          Sale Over the Last{" "}
          <sapn style={{ fontWeight: "bold", color: "red" }}>4</sapn> Days
        </div>
        <div className={style.barChartContainer}>
          <BarChart
            width={500}
            height={300}
            data={salesGraph?.length ? salesGraph : [{ date: "", amt: 0 }]}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 14, fontWeight: "bold", fill: "#555" }}
            />
            <YAxis domain={[0, 1000]} />
            <Bar
              dataKey="amt"
              fill="#8884d8"
              shape={<TriangleBar />}
              label={{ position: "top" }}
              barSize={60}
            >
              {(salesGraph.length ? salesGraph : [{ amt: 0 }]).map(
                (entry, index) => (
                  <Cell
                    key={`cell-${index}`}
                    fill={colors[index % colors.length]}
                  />
                )
              )}
            </Bar>
          </BarChart>
        </div>
        <div className={style.purchasesCard}>
          <div className={style.purchasesHeader}>Purchase</div>
          <div className={style.purchasesContent}>
            <Row justify="space-between">
              <Typography.Text className={style.purchasesText}>
                Total Bills: <b>{totalPurchaseBill}</b>
              </Typography.Text>
              <Typography.Text className={style.purchasesText}>
                Total Purchase: <b>₹ {totalPurchaseAmt?.toFixed(2) || 0}</b>
              </Typography.Text>
            </Row>
          </div>
        </div>
        <div className={style.totalPurchasesTitle}>Total Purchase</div>
        <div className={style.barChartContainer}>
          <BarChart
            width={500}
            height={300}
            data={
              totalPurchaseGraph.length
                ? totalPurchaseGraph
                : [{ date: "", amt: 0 }]
            }
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 14, fontWeight: "bold", fill: "#555" }}
            />
            <YAxis domain={[0, 1000]} />
            {totalPurchaseGraph.length && (
              <Tooltip content={<CustomTooltip />} />
            )}
            <Bar
              dataKey="amt"
              fill="#8884d8"
              label={{ position: "top" }}
              barSize={60}
            >
              {(totalPurchaseGraph.length
                ? totalPurchaseGraph
                : [{ amt: 0 }]
              ).map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={barColors[index % barColors.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </div>
        <div className={style.occasionCard}>
          <Row
            gutter={[16, 16]}
            justify="center"
            align="middle"
            className={style.occasionRow}
          >
            <Col xs={24} sm={10} md={10} className={style.occasionCol}>
              <div className={style.occasionItem}>
                <Badge badgeContent={birthDayData.length} color="warning">
                  <CakeOutlinedIcon
                    className={`${style.occasionIcon} ${style.birthdayIcon}`}
                    onClick={() => {
                      navigate("/crm");
                    }}
                  />
                </Badge>
                <p
                  className={style.occasionTitle}
                  onClick={() => {
                    navigate("/crm");
                  }}
                >
                  Birthday
                </p>
                <Button
                  type="primary"
                  className={style.checkButton}
                  onClick={() => {
                    navigate("/crm");
                  }}
                >
                  Check &gt;
                </Button>
              </div>
            </Col>
            <Col xs={0} sm={1} md={1} className={style.divider}>
              <div className={style.verticalLine}></div>
            </Col>
            <Col xs={24} sm={10} md={10} className={style.occasionCol}>
              <div className={style.occasionItem}>
                <Badge
                  badgeContent={todayAnniversaryData.length}
                  color="success"
                >
                  <HeartOutlined
                    className={`${style.occasionIcon} ${style.anniversaryIcon}`}
                    onClick={() => {
                      navigate("/crm");
                    }}
                  />
                </Badge>
                <p
                  className={style.occasionTitle}
                  onClick={() => {
                    navigate("/crm");
                  }}
                >
                  Anniversary
                </p>
                <Button
                  type="primary"
                  className={style.checkButton}
                  onClick={() => {
                    navigate("/crm");
                  }}
                >
                  Check &gt;
                </Button>
              </div>
            </Col>
          </Row>
        </div>

        <div className={style.invoicesTitle}>INVOICES</div>
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            whiteSpace: "nowrap",
            padding: "5px",
          }}
        >
          <div style={{ display: "flex", gap: "10px" }}>
            {topTenInvoices.map((invoice) => (
              <div
                key={invoice.id}
                style={{
                  minWidth: "300px",
                  background:
                    "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                  padding: "10px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.08)",
                  // border: "1px solid #52bd91",
                  display: "inline-block",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                    color: "#555",
                    marginBottom: "10px",
                  }}
                >
                  <span>
                    Invoice No:{" "}
                    <span
                      style={{
                        color: "#162566",
                        fontWeight: "bold",
                        fontSize: "16px",
                      }}
                    >
                      {invoice.billno}
                    </span>
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "14px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "rgb(210, 164, 99)",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        QTY:
                      </span>
                      <span
                        style={{
                          fontSize: "16px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        {invoice.QTY}
                      </span>
                    </span>
                    {/* <span>
                    Amount:{" "}
                    <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                      ₹ {invoice.AMOUNT.toFixed(2)}
                    </span>
                  </span> */}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "rgb(90, 171, 196)",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          fontSize: "14px",
                          color: "#595a60",
                          fontWeight: "bold",
                        }}
                      >
                        Amount:
                      </span>
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {invoice.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>

                <div style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {invoice.CustName}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <SidebarDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        singleImage={singleImage}
        userArea={userArea}
        userName={userName}
      />
    </div>
  );
};

export default Dashboard;
